<template>
  <div class="col-lg-12 control-section">
    <div class="tree-control-wrapper">
      <ejs-treeview ref='neTreeForDataSearch' id='neTreeForDataSearch' :allowSelection='false' :fields='fieldsForDataSearch' :nodeChecked='nodeCheckedOfNeTreeForDataSearch' :showCheckBox='true'></ejs-treeview>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NeTreeForDataSearch',
  props: [
    'checkedNodesOfNeTree'
  ],
  data() {
    return {
      fieldsForDataSearch: {
        dataSource: [{ children: [] }],
        id: 'id',
        text: 'text',
        child: 'children',
        expanded: 'state',
        tooltip: 'text'
      },
      checkedNodesOfNeTreeForDataSearch: []
    };
  },
  methods: {
    getNeTreeForDataSearch(neTypeId,measureTypeCode) {
      this.$axios.post(`/lte/pm/getNeTree.html?systemId=1&neTypeId=${neTypeId}&neVersionId=V16B.006&measureTypeCode=${measureTypeCode}`).then((response) => {
        this.fieldsForDataSearch = {
          dataSource: response.data,
          id: 'id',
          text: 'text',
          child: 'children',
          expanded: 'state'
        };
      });
    },
    nodeCheckedOfNeTreeForDataSearch(args) {
      //临时存储上一次的结果
      let tempOfSelectedNodes = {};
      for ( let i = 0; i < this.checkedNodesOfNeTreeForDataSearch.length; i++) {
        tempOfSelectedNodes[this.checkedNodesOfNeTreeForDataSearch[i]['id']] = this.checkedNodesOfNeTreeForDataSearch[i]['id'];
      }

      //针对本次变化处理
      for (let i = 0;  i < args.data.length; i++) {
        if(args.action==="check"){
          if(tempOfSelectedNodes[args.data[i].id]){
            //如果上次就已经选中了，本次就不能重复填加了
          }else{
            tempOfSelectedNodes[args.data[i].id]=args.data[i].id;
          }

        }else{
          delete tempOfSelectedNodes[args.data[i].id];
        }
      }

      const checkedNodes = [];

      for(let item in tempOfSelectedNodes){
        checkedNodes.push(item);
      }


      let selectedNodes = [];

      let dataList = this.$refs.neTreeForDataSearch.getTreeData()[0].children[0].children;

      for(let index = 0; index < dataList.length; index++){
        console.log(dataList[index]);
        if(checkedNodes.indexOf(dataList[index].id) != -1){
          selectedNodes.push(dataList[index]);
        }
      }

      this.checkedNodesOfNeTreeForDataSearch = selectedNodes;
    }
  },
  watch: {
    checkedNodesOfNeTree(checkedNodesOfNeTree) {
      this.checkedNodesOfNeTreeForDataSearch = checkedNodesOfNeTree;
    }
  },
  mounted() {
    // this.getNeTreeForDataSearch();
  }
};
</script>

<style>

</style>
